import { captureException } from "@sentry/react";
import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { PlanActionTypes } from "../models/planActions";

export default (data: {
    type: string,
    editor: boolean,
    planId: string,
    page: string,
    isExperience: boolean,
}) => async (dispatch: Dispatch<PlanActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post("/task-completed", { ...data, standalone: "standalone" in window.navigator && window.navigator["standalone"] });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
        captureException(error);
    }
};